export default __webpack_public_path__ + "static/coninsa-process-0d0563de875197b3734cdc9b3bb96463.png";